export const detectTerminationIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete termination" || cleaned === "remove termination") {
        return { intent: "delete_termination" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) termination/);
    if (deleteMatch) {
        return { intent: "delete_termination", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create termination") || cleaned.includes("add termination")) {
        return { intent: "create_termination" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create termination named (.+)/);
    if (createMatch) {
        return { intent: "create_termination", name: createMatch[1].trim() };
    }

    return null;
};
